import VuexPersistence from 'vuex-persist'
import { encryptStorage } from './encrypted-storage.js';

const vuexLocal = new VuexPersistence({
  storage: encryptStorage
})

export default vuexLocal